import Vue from 'vue'
import {AclCreate, AclInstaller, AclRule} from 'vue-acl'
import router from '@/router'


Vue.use(AclInstaller)
let initialRole = 'guest'
 
const userRoles = JSON.parse(localStorage.getItem('userRoles'))

if (Array.isArray(userRoles)) initialRole = userRoles[0].name

const setUserRoles = {
  guest: new AclRule('user').or('manager').or('kvsupport').or('center').or('admin').or('guest').or('teacher').or('blog').generate(),
  user: new AclRule('user').or('manager').or('kvsupport').or('center').or('admin').or('teacher').or('blog').generate(),
  blog: new AclRule('blog').or('manager').or('kvsupport').or('center').or('admin').or('teacher').generate(),
  teacher: new AclRule('teacher').or('manager').or('kvsupport').or('center').or('admin').generate(),
  manager: new AclRule('manager').or('kvsupport').or('center').or('admin').generate(),
  kvsupport: new AclRule('kvsupport').or('center').or('admin').generate(),
  center: new AclRule('center').or('admin').generate(),
  admin: new AclRule('admin').generate()

}

export default new AclCreate({
  initial: initialRole,
  notfound: '/login',
  router,
  acceptLocalRules: true,

  globalRules: setUserRoles
})
